import React from 'react';
import { Flex, Box } from 'rebass';
import { Formik, FormikConfig } from 'formik';
import * as Yup from 'yup';

import {
  FormSubHeader,
  FormHeader,
  ErrorNotification,
  PasswordField,
  ButtonLarge,
  BackToLogin,
} from '@mdlinx/component-library';

export interface PasswordResetFormProps {
  onSubmit: FormikConfig<{
    newPassword: string;
    confirmPassword: string;
  }>['onSubmit'];
  onClickBack?: () => void;
  errorMessage?: string;
}

export const PasswordResetForm = ({ onSubmit, onClickBack, errorMessage }: PasswordResetFormProps) => {
  return (
    <Flex flexDirection="column">
      <FormHeader>Reset Password</FormHeader>
      <Box mt="12px" />
      <FormSubHeader>Please provide a new password.</FormSubHeader>
      <Box mt="20px" />
      {errorMessage && (
        <Box my="10px">
          <ErrorNotification errorMessage={errorMessage} />
        </Box>
      )}
      <Box width="100%" mb={['50px']}>
        <Formik
          initialValues={{ newPassword: '', confirmPassword: '' }}
          validationSchema={Yup.object({
            newPassword: Yup.string().required('Required'),
            confirmPassword: Yup.string()
              .oneOf([Yup.ref('newPassword'), undefined], "Passwords don't match")
              .required('Password confirm is required'),
          })}
          onSubmit={onSubmit}
        >
          {formik => (
            <>
              <PasswordField label="New Password" name="newPassword" />
              <Box mt="22px" />
              <PasswordField label="Confirm Password" name="confirmPassword" />
              <Box mt="20px">
                <Box width={['100%', '132px']}>
                  <ButtonLarge type="submit" disabled={!(formik.dirty && formik.isValid)} onClick={formik.handleSubmit}>
                    Continue
                  </ButtonLarge>
                </Box>
              </Box>
            </>
          )}
        </Formik>
      </Box>
      <BackToLogin onClick={onClickBack} />
    </Flex>
  );
};
